export var generateInfoScreen = function generateInfoScreen(battlesAssets) {
  return [battlesAssets.BATTLES_INFO_SCREEN_1, battlesAssets.BATTLES_INFO_SCREEN_2, battlesAssets.BATTLES_INFO_SCREEN_3, battlesAssets.BATTLES_INFO_SCREEN_4];
};